import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import * as Mui from "@mui/material";
import {
  themes,
  scrollTop,
  optionalAvathar,
  tableRowSx,
  stickyHeader,
  tableRowSize,
} from "services/constants";
import { runPayrollGroupHeaders } from "pages/PayRoll/PayRollHeaders";
import { RemoveRedEye, Description, Downloading } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { KeyboardArrowRight, KeyboardArrowDown } from "@mui/icons-material";
import { GroupEmployee } from "pages/PayRoll/PayRollHeaders";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { tooltipStyleProps } from "services/constants/Styles";
import { customGetAPI } from "services/utils/CustomAPI";
import { CompanyProgress } from "components/CustomComponents/CustomSlider";
import comLogo from "../../../../../../assets/img/brand/company_logo.png";
import { Loader } from "components/Loader";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { showToast } from "services/utils/Status";
import { usePayrollCycleRun } from "../../PayrollCycleRunContext";
import sessionHandling from "services/utils/notificationUtils";
import { BlobProvider, pdf } from "@react-pdf/renderer";
import { getTemplateById } from "pages/PayRoll/PayslipTemplates/templates";
import { DoubleArrow, Download } from "@mui/icons-material";
import moment from "moment";

export const GroupDetails = ({ companyId, setIsViewPanelOpen }) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, token, topbarCompanyName } = useSelector(
    (state) => state.tokenReducer,
  );
  const activeTemplateId = useSelector(
    (state) => state.userReducer.payslipTemplateId,
  );
  const { SingleDocument, BulkDocument } = getTemplateById(activeTemplateId);
  const { payScheduleId, setUserId } = usePayrollCycleRun();
  const [listViewPage, setListViewPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [expandedRow, setExpandedRow] = useState(0);
  const containerRef = useRef(null);
  const [fetchUserDetails, setFetchUserDetails] = useState(false);
  const [groupEmployee, setGroupEmployee] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [hanldeLoading, setHanldeLoading] = useState(false);
  const [pslipOpenDialog, setPslipOpenDialog] = useState(false);
  const [indPayslipData, setIndPayslipData] = useState(null);
  const [pdfKey, setPdfKey] = useState(0);
  const iframeRef = useRef(null);
  const [generatingPayslipGroups, setGeneratingPayslipGroups] = useState({});

  let check_access = true;

  const { result: apiData, loading } = useFetch(
    `${domain}payroll/operations/payrollprocessing/payrollruncycle/payrun-group/?pay_schedule_id=${payScheduleId}&company_id=${requestCompanyId}`,
  );

  useEffect(() => {
    const fetchAllUsers = async () => {
      setHanldeLoading(true);
      try {
        const res = await customGetAPI(
          `${domain}payroll/operations/payrollprocessing/payrollruncycle/payrun-group-users/?shift_group_id=${expandedRow}&pay_schedule_id=${payScheduleId}&company_id=${requestCompanyId}`,
        );
        if (res.ok) {
          setGroupEmployee(res?.responseDetails);
        } else {
          setGroupEmployee([]);
        }
      } catch (error) {
        console.error("[Groupdetails] operation failed:", error);
        showToast("error", error);
        setGroupEmployee([]);
      } finally {
        setHanldeLoading(false);
      }
    };

    if (fetchUserDetails && expandedRow) {
      fetchAllUsers();
    }
  }, [domain, expandedRow, fetchUserDetails, payScheduleId, requestCompanyId]);

  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };

  const handleRowClick = (details) => {
    if (expandedRow === details?.id) {
      setExpandedRow(0);
      setGroupEmployee([]);
    } else {
      setExpandedRow(details?.id);
      setFetchUserDetails(true);
      setGroupEmployee([]);
    }
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [listViewPage]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setGroupData(filteredData);
      if (listViewPage * rowsPerPage >= filteredData.length) setListViewPage(0);
    },
    [listViewPage, rowsPerPage],
  );

  const getPayslipData = async (payschle) => {
    try {
      console.log(payschle);
      const response = await fetch(
        `${domain}payroll/operations/payrollprocessing/payrollruncycle/get-payslip-details/?user_id=${payschle?.user_id}&pay_schedule_id=${payschle?.pay_schedule}&company_id=${requestCompanyId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        },
      );
      const jsonData = await response.json();
      if (response.ok) {
        setIndPayslipData({
          ...jsonData,
          employee_id: payschle?.employee_id,
        });
        setPslipOpenDialog(true);
        setPdfKey((prev) => prev + 1);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(jsonData?.error);
      }
    } catch (error) {
      console.error("[Groupdetails] operation failed:", error);
      showToast(
        "error",
        "Couldn't load payroll details. Please refresh the page.",
      );
      setIndPayslipData(null);
      setPslipOpenDialog(false);
    }
  };

  const handlePress = async (payschle) => {
    try {
      await getPayslipData(payschle);
    } catch (error) {
      console.error("[Groupdetails] operation failed:", error);
      showToast(
        "error",
        "Couldn't load payroll details. Please refresh the page.",
      );
    }
  };

  const toggleDrawer = () => {
    setPslipOpenDialog(false);
    setIndPayslipData(null);
    if (iframeRef.current) {
      iframeRef.current.src = "";
    }
  };

  const generateBulkPayslip = async (
    group_details,
    group_user_details,
    groupId,
  ) => {
    if (!group_user_details || group_user_details.length === 0) {
      showToast("error", "No employee data available to generate payslips");
      return;
    }

    setGeneratingPayslipGroups((prev) => ({ ...prev, [groupId]: true }));

    try {
      const employeesWithPayslipData = await Promise.all(
        group_user_details.map(async (employee) => {
          try {
            const response = await fetch(
              `${domain}payroll/operations/payrollprocessing/payrollruncycle/get-payslip-details/?user_id=${employee?.user_id}&pay_schedule_id=${payScheduleId}&company_id=${requestCompanyId}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `token ${token}`,
                },
              },
            );

            if (!response.ok) return null;

            const payslipData = await response.json();

            if (!payslipData || payslipData?.error) return null;

            return {
              ...employee,
              payslipData: {
                ...payslipData,
                employee_id: employee?.employee_id,
              },
            };
          } catch (err) {
            console.error("Payslip fetch error:", employee?.user_name, err);
            return null;
          }
        }),
      );

      const validEmployees = employeesWithPayslipData.filter(
        (emp) => emp && emp?.payslipData,
      );

      if (!validEmployees.length) {
        showToast("error", "No valid payslip data available to generate PDF");
        return;
      }

      const blob = await pdf(
        <BulkDocument employeesPdfData={validEmployees} />,
      ).toBlob();

      if (!blob) {
        showToast("error", "Failed to generate PDF file");
        return;
      }

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${group_details?.name ?? "Payslips"}.pdf`;

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error(error);
      showToast("error", `Failed to generate PDF: ${error?.message}`);
    } finally {
      setGeneratingPayslipGroups((prev) => ({ ...prev, [groupId]: false }));
    }
  };

  const reportMetadata = useMemo(
    () => ({
      "Company Name": topbarCompanyName || "N/A",
      "Report Generated On": moment().format("DD/MM/YYYY HH:mm:ss"),
    }),
    [topbarCompanyName],
  );

  return loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Mui.Box>
        <CustomFilter
          title="Group Records"
          filterHeaders={runPayrollGroupHeaders}
          data={apiData}
          filteredData={groupData}
          onFilteredDataChange={handleFilteredDataChange}
          screenAccess={check_access}
          showSaveButton={false}
          downloadFormats={["excel", "pdf", "csv"]}
          includeMetadata={true}
          metadata={reportMetadata}
        />

        <Mui.Grid sx={{ ml: 2, mr: 2 }}>
          <Mui.TableContainer
            ref={containerRef}
            sx={{ mt: 2, width: "100%", maxHeight: 500 }}
          >
            <Mui.Table className="border">
              <Mui.TableHead sx={stickyHeader}>
                <Mui.TableRow sx={tableRowSx}>
                  <Mui.TableCell sx={{ maxWidth: "50px" }}></Mui.TableCell>
                  {runPayrollGroupHeaders.map((header) => (
                    <Mui.TableCell
                      key={header.key}
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        maxWidth:
                          header.name === "Group name" ? "200px" : "120px",
                      }}
                    >
                      {header.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {groupData?.length === 0 ? (
                  <TableEmptyState dataLength={apiData} />
                ) : (
                  groupData
                    ?.slice(
                      listViewPage * rowsPerPage,
                      listViewPage * rowsPerPage + rowsPerPage,
                    )
                    .map((group_details) => (
                      <React.Fragment key={group_details.id}>
                        <Mui.TableRow sx={tableRowSx}>
                          <Mui.TableCell sx={{ maxWidth: "50px" }}>
                            <Mui.IconButton
                              onClick={() => handleRowClick(group_details)}
                            >
                              {group_details?.id === expandedRow ? (
                                <KeyboardArrowDown />
                              ) : (
                                <KeyboardArrowRight />
                              )}
                            </Mui.IconButton>
                          </Mui.TableCell>
                          {runPayrollGroupHeaders.map((header) =>
                            header?.key === "Action" ? (
                              <Mui.TableCell key={header.key}>
                                <Mui.IconButton
                                  onClick={() => {
                                    generateBulkPayslip(
                                      group_details,
                                      group_details.user_details,
                                      group_details.id,
                                    );
                                  }}
                                  disabled={
                                    generatingPayslipGroups[
                                      group_details.group_id
                                    ]
                                  }
                                >
                                  {generatingPayslipGroups[
                                    group_details.group_id
                                  ] ? (
                                    <Downloading
                                      sx={{
                                        color: themes.redColor,
                                        strokeWidth: 2,
                                      }}
                                    />
                                  ) : (
                                    <Description
                                      sx={{
                                        color: themes.redColor,
                                        strokeWidth: 2,
                                      }}
                                    />
                                  )}
                                </Mui.IconButton>
                              </Mui.TableCell>
                            ) : (
                              <Mui.TableCell
                                key={header.key}
                                sx={{
                                  color: themes.headLine,
                                  maxWidth:
                                    header.name === "Group name"
                                      ? "200px"
                                      : "120px",
                                }}
                              >
                                {group_details[header.key] ?? "N/A"}
                              </Mui.TableCell>
                            ),
                          )}
                        </Mui.TableRow>
                        {group_details?.id === expandedRow && (
                          <Mui.TableRow sx={tableRowSx}>
                            <Mui.TableCell colSpan={12}>
                              <Mui.TableContainer sx={{ maxHeight: 200 }}>
                                <Mui.Table className="border">
                                  <Mui.TableHead sx={stickyHeader}>
                                    {GroupEmployee.map((header) => (
                                      <Mui.TableCell
                                        key={header.key}
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {header.name}
                                      </Mui.TableCell>
                                    ))}
                                    <Mui.TableCell
                                      sx={{
                                        color: themes.headLine,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Action
                                    </Mui.TableCell>
                                  </Mui.TableHead>
                                  <Mui.TableBody>
                                    {hanldeLoading ? (
                                      <Mui.TableRow sx={tableRowSize}>
                                        <Mui.TableCell
                                          colSpan={GroupEmployee.length + 1}
                                          style={{ textAlign: "center" }}
                                        >
                                          <CompanyProgress
                                            comLogo={comLogo}
                                            themes={themes}
                                          />
                                        </Mui.TableCell>
                                      </Mui.TableRow>
                                    ) : groupEmployee.length === 0 ? (
                                      <Mui.TableRow sx={tableRowSize}>
                                        <Mui.TableCell
                                          colSpan={GroupEmployee.length + 1}
                                        >
                                          <Mui.Alert
                                            sx={{ marginTop: 3 }}
                                            severity="info"
                                          >
                                            No data available
                                          </Mui.Alert>
                                        </Mui.TableCell>
                                      </Mui.TableRow>
                                    ) : (
                                      groupEmployee?.map(
                                        (group_employee_details, i) => (
                                          <Mui.TableRow key={i} sx={tableRowSx}>
                                            {GroupEmployee.map(
                                              (header, idx) => (
                                                <Mui.TableCell
                                                  key={idx}
                                                  sx={{
                                                    color: themes.headLine,
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  {group_employee_details[
                                                    header.key
                                                  ] ||
                                                  group_employee_details[
                                                    header.key
                                                  ] === 0 ? (
                                                    header.name ===
                                                    "Employee name" ? (
                                                      <Mui.Stack
                                                        direction="row"
                                                        alignItems="center"
                                                      >
                                                        <Mui.Avatar
                                                          sx={{
                                                            width: 23,
                                                            height: 23,
                                                          }}
                                                          alt={group_employee_details?.employee_name
                                                            ?.charAt(0)
                                                            .toUpperCase()}
                                                          src={
                                                            group_employee_details?.image_url ??
                                                            optionalAvathar
                                                          }
                                                        />
                                                        &nbsp;
                                                        {
                                                          group_employee_details?.employee_name
                                                        }
                                                      </Mui.Stack>
                                                    ) : (
                                                      group_employee_details[
                                                        header.key
                                                      ]
                                                    )
                                                  ) : (
                                                    "N/A"
                                                  )}
                                                </Mui.TableCell>
                                              ),
                                            )}

                                            <Mui.TableCell>
                                              <Mui.Tooltip
                                                arrow
                                                slotProps={tooltipStyleProps}
                                                title="View payment details"
                                              >
                                                <Mui.IconButton
                                                  onClick={() => {
                                                    setUserId(
                                                      group_employee_details?.user_id,
                                                    );

                                                    setIsViewPanelOpen(true);
                                                  }}
                                                >
                                                  <RemoveRedEye
                                                    sx={{
                                                      color:
                                                        themes.primaryIndicator,
                                                      strokeWidth: 2,
                                                    }}
                                                  />
                                                </Mui.IconButton>
                                                <Mui.IconButton
                                                  onClick={() => {
                                                    handlePress(
                                                      group_employee_details,
                                                    );
                                                  }}
                                                >
                                                  <Description
                                                    sx={{
                                                      cursor: "pointer",
                                                      color: themes.redColor,
                                                      strokeWidth: 2,
                                                    }}
                                                  />
                                                </Mui.IconButton>
                                              </Mui.Tooltip>
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        ),
                                      )
                                    )}
                                  </Mui.TableBody>
                                </Mui.Table>
                              </Mui.TableContainer>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        )}
                      </React.Fragment>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
          {groupData?.length > 25 ? (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={groupData?.length}
              rowsPerPage={rowsPerPage}
              page={listViewPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          ) : null}
        </Mui.Grid>
      </Mui.Box>

      {pslipOpenDialog && indPayslipData && (
        <Mui.Drawer
          anchor="right"
          open={pslipOpenDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
            toggleDrawer();
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: "680px",
              backgroundColor: themes?.whiteColor,
            },
          }}
        >
          <Mui.Box
            sx={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Mui.Paper
              elevation={0}
              sx={{
                borderBottom: `1px solid ${themes?.miliedLightGray}`,
                borderRadius: 0,
              }}
            >
              <Mui.Box sx={{ padding: 1, backgroundColor: themes?.primary }}>
                <Mui.Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Mui.Box sx={{ ml: 1 }}>
                    <Mui.IconButton
                      onClick={toggleDrawer}
                      sx={{
                        color: themes?.grayColor,
                        "&:hover": {
                          backgroundColor: themes?.whiteColor,
                        },
                      }}
                    >
                      <DoubleArrow />
                    </Mui.IconButton>
                  </Mui.Box>
                  <BlobProvider
                    key={pdfKey}
                    document={<SingleDocument payslipData={indPayslipData} />}
                  >
                    {({ blob, url, loading }) => (
                      <>
                        <Mui.IconButton
                          disabled={loading || !url}
                          onClick={() => {
                            if (url) {
                              const link = document.createElement("a");
                              link.href = url;
                              link.download = `${
                                indPayslipData?.user_name +
                                  indPayslipData?.pay_schedule_name || "payslip"
                              }.pdf`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }
                          }}
                          sx={{
                            color: themes?.greenColor,
                            backgroundColor: themes?.primary,
                            borderRadius: "50%",
                            "&:hover": { backgroundColor: themes?.primary },
                            mr: 2,
                            mt: 0.5,
                          }}
                        >
                          <Download />
                        </Mui.IconButton>
                      </>
                    )}
                  </BlobProvider>
                </Mui.Box>

                <Mui.Box sx={{ ml: 2.2 }}>
                  <Mui.Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {indPayslipData?.user_name +
                      indPayslipData?.pay_schedule_name || "payslip"}
                  </Mui.Typography>
                </Mui.Box>
              </Mui.Box>
            </Mui.Paper>

            <Mui.Box sx={{ flex: 1, overflow: "auto" }}>
              <BlobProvider
                key={pdfKey}
                document={<SingleDocument payslipData={indPayslipData} />}
              >
                {({ blob, url, loading }) => {
                  if (loading) {
                    return <Loader info="Generating PDF..." />;
                  }
                  if (url) {
                    return (
                      <iframe
                        ref={iframeRef}
                        src={url}
                        style={{
                          width: "100%",
                          height: "100%",
                          minHeight: "calc(100vh - 64px)",
                          border: "none",
                        }}
                        title="Payslip Preview"
                      />
                    );
                  }
                  return null;
                }}
              </BlobProvider>
            </Mui.Box>
          </Mui.Box>
        </Mui.Drawer>
      )}
    </React.Fragment>
  );
};
